import { useEffect } from "react";
import { useI18n } from "@/i18n";

const SITE_SUFFIX = "PrzyStań w Ciszy";

export default function usePageMeta(title, description) {
  const { lang } = useI18n();

  useEffect(() => {
    if (title) document.title = title;
    document.documentElement.lang = lang;

    const setMeta = (attr, key, content) => {
      if (!content) return;
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    const setLink = (rel, hreflang, href) => {
      const sel = hreflang
        ? `link[rel="${rel}"][hreflang="${hreflang}"]`
        : `link[rel="${rel}"]`;
      let el = document.head.querySelector(sel);
      if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        if (hreflang) el.setAttribute("hreflang", hreflang);
        document.head.appendChild(el);
      }
      el.setAttribute("href", href);
    };

    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:site_name", SITE_SUFFIX);
    setMeta("property", "og:type", "website");

    // Locale signals so search engines serve the right language to foreign guests
    const locale = lang === "pl" ? "pl_PL" : "en_US";
    const altLocale = lang === "pl" ? "en_US" : "pl_PL";
    setMeta("property", "og:locale", locale);
    setMeta("property", "og:locale:alternate", altLocale);

    // Canonical + hreflang alternates (same SPA URL serves both languages)
    const url = window.location.origin + window.location.pathname;
    setLink("canonical", null, url);
    setMeta("property", "og:url", url);
    setLink("alternate", "pl", url);
    setLink("alternate", "en", url);
    setLink("alternate", "x-default", url);
  }, [title, description, lang]);
}
